import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ChatTitle = styled.div`
	cursor: pointer;
`;

export const ChatList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin-top: 2rem;
`;

export const ChatListWrapper = styled.div`
	overflow-y: auto;
`;

export const Divider = styled.div`
	width: 1px;
	background-color: var(--border-color);
	height: 100%;
	flex-shrink: 0;

	@media ${Breakpoints.mobile} {
		display: none;
	}
`;

export const ChatHistoryBlock = styled.div`
	padding: 0 2rem 0 3rem;
	margin-bottom: 4rem;

	body[dir='rtl'] & {
		padding: 0 3rem 0 2rem;
	}
`;

export const HistoryWrapper = styled.div`
	padding: 2rem 0 2rem 2rem;
	width: 50%;
	height: 100%;
	display: flex;
	flex-direction: column;

	body[dir='rtl'] & {
		padding: 2rem 2rem 2rem 0;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
		height: 40%;
		border-top: 1px solid var(--border-color);
	}
`;

export const HistoryHeaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin-top: 7rem;
	padding: 0 2rem;
	margin-bottom: 2rem;

	@media ${Breakpoints.mobile} {
		margin-top: 0;
		padding: 0;
	}
`;
